import React from 'react';
import { MailIcon, InstagramIcon, GlobeIcon } from 'lucide-react';
export function Footer() {
  return <footer className="border-t border-grape/15 bg-white/70" data-id="element-69" data-mp="3gfitaf6445cj">
      <div className="mx-auto max-w-4xl px-5 py-12 text-center" style={{
      paddingTop: "25px"
    }} data-id="element-70" data-mp="32nukolv2nz0b">
        <p className="font-display text-xl font-black text-plum" data-id="element-71" data-mp="32m1ef7odfgsu">
          THE K-SMART VISUAL SYSTEM<span className="align-super text-xs" data-id="element-72" data-mp="36n3chl6jxmt8">™</span>
        </p>
        <p className="mx-auto mt-3 max-w-xl text-sm leading-relaxed text-plum/65" data-id="element-73" data-mp="3ufjvpz20zku4">
          The visual method to learn Korean from absolute zero: Hangul, pronunciation, real phrases
          and K-Drama / K-Pop expressions in 30 days. Because loving Korean culture should not mean
          depending on subtitles forever.
        </p>

        <div className="mt-8 flex flex-wrap items-center justify-center gap-x-6 gap-y-3 text-sm text-plum/75" data-id="element-74" data-mp="3qf9o6hyl4md5">
          <a href="mailto:soporte.sigmasmart@gmail.com" className="inline-flex items-center gap-2 transition-colors duration-150 ease-out hover:text-grape" data-id="element-75" data-mp="2ey09e8qeiii6">
            <MailIcon className="h-4 w-4 text-grape" data-id="element-76" data-mp="3l9sjf6xt4wpj" /> soporte.sigmasmart@gmail.com
          </a>
          <a href="#" className="inline-flex items-center gap-2 transition-colors duration-150 ease-out hover:text-grape" data-id="element-77" data-mp="3gc0jbpn0e4a9">
            <InstagramIcon className="h-4 w-4 text-grape" data-id="element-78" data-mp="3v5dfypk3x4rw" /> @sigmasmart.en
          </a>
          <a href="#" className="inline-flex items-center gap-2 transition-colors duration-150 ease-out hover:text-grape" data-id="element-79" data-mp="3qapz9cvchenv">
            <GlobeIcon className="h-4 w-4 text-grape" data-id="element-80" data-mp="33xge4qruavo" /> www.sigmasmart.store
          </a>
        </div>

        <p className="mt-4 font-display text-base font-semibold italic text-grape" data-id="element-81" data-mp="hsk4ovydmcz1">
          🌸 “안녕하세요 — your first Korean word starts today.”
        </p>

        <div className="mt-8 flex flex-wrap justify-center gap-x-4 gap-y-2 text-xs text-plum/45" data-id="element-82" data-mp="cuiku8t4m9mi">
          <a href="#" className="transition-colors duration-150 ease-out hover:text-plum" data-id="element-83" data-mp="qtrpcb7yzfan">
            Terms & Conditions
          </a>
          <span data-id="element-84" data-mp="tv4iroyaqfyo">·</span>
          <a href="#" className="transition-colors duration-150 ease-out hover:text-plum" data-id="element-85" data-mp="tvw6kdlnj9ee">
            Privacy Policy
          </a>
          <span data-id="element-86" data-mp="yupiw2p7cucz">·</span>
          <a href="#" className="transition-colors duration-150 ease-out hover:text-plum" data-id="element-87" data-mp="yrv16ixkpnn9">
            Support
          </a>
        </div>

        <p className="mt-8 text-xs leading-relaxed text-plum/40" data-id="element-88" data-mp="18k959ic4j6cl">
          © 2026 THE K-SMART VISUAL SYSTEM™ — SIGMA SMART™ — All rights reserved. Reproduction and
          redistribution prohibited without express authorization.
        </p>
      </div>
    </footer>;
}